import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

export default function CheckEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = window.localStorage.getItem('emailForSignIn');
  const state = location.state as { error?: string };

  if (state?.error) {
    return (
      <Container style={{ maxWidth: '600px', marginTop: '50px' }}>
        <Alert variant="warning">
          <Alert.Heading>Account Not Found</Alert.Heading>
          <p>
            No account exists with the email address <strong>{email}</strong>.
          </p>
          <p>
            Please make sure you're using the email address that was included in the group thread.
          </p>
          <hr />
          <div className="d-flex justify-content-between">
            <Button variant="outline-primary" onClick={() => navigate('/login')}>
              Try Again
            </Button>
          </div>
        </Alert>
      </Container>
    );
  }

  return (
    <Container style={{ maxWidth: '600px', marginTop: '50px' }}>
      <Alert variant="info">
        <Alert.Heading>Check your email</Alert.Heading>
        <p>
          We've sent a login link to <strong>{email}</strong>. Click the link in the email to sign in.
        </p>
        <p>
          If you don't see the email, check your spam folder.
        </p>
        <hr />
        <div className="d-flex justify-content-between">
          <Button variant="outline-primary" onClick={() => navigate('/login')}>
            Back to Login
          </Button>
          <Button 
            variant="primary" 
            onClick={() => {
              window.localStorage.removeItem('emailForSignIn');
              navigate('/login');
            }}
          >
            Try with different email
          </Button>
        </div>
      </Alert>
    </Container>
  );
} 